import React from 'react';
import withData from '@bd/bdcore-data';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import CoreMap from '@bd/bdui-coremap';
import { get } from 'lodash';

// import AreaMapCard from '../AreaMapCard';

import { colors } from '../../../styles';

const styles = css`
  height: 100%;
  width: 100%;
`;

const communityMap = css`
  position: absolute;
  width: 100%;
  z-index: 0;
  height: 60vh;
  padding: 0;
  @media (min-width: 992px) {
    height: 800px;
    height: auto;
    position: relative;
    height: 40vh;
    width: auto;
    flex-grow: 1;
  }
  background-color: ${colors.brand3};
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content {
    min-width: 320px;
  }
  .leaflet-popup-content-wrapper {
    border-radius: 0;
    .CommunityCard_wrapper {
      width: 100% !important;
    }
    .CommunityCard_inner {
      flex-direction: column !important;
    }
    .CommunityCard_mapButton {
      display: none !important;
    }
    .CommunityCard_detailButton {
      width: 100% !important;
    }
    .CommunityCard_buttonWrapper {
      margin: 0 !important;
    }
    .CommunityCard_priceValue {
      padding: 10px 8px !important;
    }
  }
`;

function AreaMap({ areas, activeMapPin }) {
  const cities = areas.filter(item => get(item, 'parentMetro'));
  return (
    <div className={styles}>
      <CoreMap
        animate
        useFlyTo
        pin={{
          iconUrl: '/images/icon-map-pin.svg',
          iconSize: [18, 26],
          iconAnchor: [9, 26],
        }}
        boundsOptions={{ animate: true, duration: 0.5 }}
        activePin={activeMapPin}
        className={`${communityMap}`}
        markers={cities}
        popup={({ marker: area }) => (
          <div>Test {area}</div>
          // <AreaMapCard area={area} />
        )}
      />
    </div>
  );
}

AreaMap.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeMapPin: PropTypes.string,
};

AreaMap.defaultProps = {
  activeMapPin: undefined,
};

export default withData(
  {
    areas: 'all',
    activeMapPin: true,
  },
  {
    required: {
      areas: true,
    },
  },
)(AreaMap);



// WEBPACK FOOTER //
// ./src/components/Header/MenuModal/AreaMap.js